import axios from "axios";
import {
    COMMUNICATION_REQUEST,
    COMMUNICATION_SUCCESS,
    COMMUNICATION_FAIL,
    COMMUNICATION_CLEAR_ERRORS
} from "../Constants/communicarion_const";

export const get_communication = () => async (dispatch) => {
  try {
    dispatch({
      type: COMMUNICATION_REQUEST,
    });
    const communication = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/communication/`
    );
    dispatch({
      type: COMMUNICATION_SUCCESS,
      payload: communication,
    });
  } catch (error) {
    dispatch({
      type: COMMUNICATION_FAIL,
      payload: error.response,
    });
  }
};

export const add_communication =
  (communication_payload) => async (dispatch) => {
    try {
      dispatch({
        type: COMMUNICATION_REQUEST,
      });
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/communication/`,
        communication_payload
      );
      const communication = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/communication/`
      );

      dispatch({
        type: COMMUNICATION_SUCCESS,
        payload: communication,
      });
    } catch (error) {
      dispatch({
        type: COMMUNICATION_FAIL,
        payload: error.response,
      });
    }
  };

export const update_communication =
  (communication_payload, id) => async (dispatch) => {
    try {
      dispatch({
        type: COMMUNICATION_REQUEST,
      });
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/communication/${id}/`,
        communication_payload
      );
      const communication = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/communication/`
      );

      dispatch({
        type: COMMUNICATION_SUCCESS,
        payload: communication,
      });
    } catch (error) {
      dispatch({
        type: COMMUNICATION_FAIL,
        payload: error.response,
      });
    }
  };

export const delete_communication = (id) => async (dispatch) => {
  try {
    dispatch({
      type: COMMUNICATION_REQUEST,
    });
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/communication/${id}/`
    );
    const communication = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/communication/`
    );

    dispatch({
      type: COMMUNICATION_SUCCESS,
      payload: communication,
    });
  } catch (error) {
    dispatch({
      type: COMMUNICATION_FAIL,
      payload: error.response,
    });
  }
};
export const communication_clearErrors = () => async (dispatch) => {
  dispatch({
    type: COMMUNICATION_CLEAR_ERRORS,
  });
};
